import { API_URL } from "@/lib/api-client";

/**
 * プレビュー対象の URL が自前バックエンド(API_URL)由来かどうか。
 * S3 presigned URL は署名で認証されるため false、ローカルのストリーミング
 * エンドポイントは Cookie 認証が必要なため true。
 */
export function isOwnApiUrl(url: string): boolean {
	return url === API_URL || url.startsWith(`${API_URL}/`) || url.startsWith(`${API_URL}?`);
}
